const ESIA_AUTH_STATUS = {
	SUCCESS: 'Success',
	NOT_TRUSTED_ESIA_USER: 'NotTrustedEsiaUser',
	NOT_FOUND: 'NotFound',
	INVALID_PERSON_TYPE: 'InvalidPersonType',
	STABLE_PERSONAL_DATA_MISSMATCH: 'StablePersonalDataMismatch',
};

export { ESIA_AUTH_STATUS };